import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { getGatewaysWithMachines as fetchGatewaysWithMachines } from "../client-configuration/get-gateways-with-machines";

export const getGatewaysWithMachines = async () => {
  try {
    const namespace = store.getState().yourSlice.authContext?.customerNamespace;
    if (!namespace) {
      throw new Error("Customer namespace is unavailable.");
    }

    return await fetchGatewaysWithMachines(namespace);
  } catch (error) {
    const { status } = parseAxiosApiError(
      error,
      "Failed to fetch gateways with machines.",
    );
    navigateTo(status === 403 ? Route.PERMISSION_DENIED : Route.SERVER_ERROR);
  }
};
